exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/user-avatar/user-avatar.component.css
// module id = 867
// module chunks = 0